{
    "actions": {
        "page": {
            "add_clients": "Ajouter des clients autorisés",
            "create_plan": "Nouvelle offre",
            "new_pos": {
                "unblock": "Déblocage nouveaux TPE",
                "block": "Blocage nouveaux TPE"
            },
            "receive_alerts": "Recevoir des alertes",
            "update_offer": "Modifier l'offre"
        },
        "row": {
            "delete_access": "Supprimer l'accès",
            "parent_plans": {
                "delete": "Supprimer l'accès à {{labelName}}"
            }
        }
    },
    "keys": {
        "parent_subscription_label": "Offre fournisseur",
        "label": "Libellé offre client",
        "product_code": "Code offre client",
        "created_at": "Date de création",
        "updated_at": "MAJ le",
        "auto_activate": "Activation automatique des abonnements",
        "auto_activate_short": "Activation automatique",
        "auto_activate_alert": "Tous les nouveaux abonnements enregistrés automatiquement seront activés sur cette offre dès leur connexion à la plateforme."
    },
    "filter": {
        "placeholder": {
            "parent_subscription_label": "Filtrer offre fournisseur",
            "label": "Filtrer par libellé offre client",
            "product_code": "Filtrer par code offre client",
            "organization": "Filtrer par nom d'organisation"
        }
    },
    "info": {
        "block_new_pos": "Le blocage des nouveaux terminaux est activé"
    },
    "modal": {
        "add_allowed_clients": {
            "title": "Ajouter des clients autorisés",
            "success": "Client ajouté avec succès !"
        },
        "update_plan": {
            "title": "Modifier l'offre",
            "success": "Offre mise à jour avec succès !",
            "auto_activate": {
                "yes": "Oui",
                "no": "Non",
                "warning": "Cette option ne peut être activée que sur une seule offre. Si vous l’activez pour cette offre, elle sera désactivée sur l’offre précédente."
            }
        },
        "create_plan": {
            "title": "Ajouter une offre",
            "steps": {
                "plan_selection": "Étape {{step}} sur {{maxStep}} : Sélectionner une offre fournisseur",
                "form": "Étape {{step}} sur {{maxStep}} : Détails de l'offre"
            }
        },
        "block_new_pos": {
            "title": "Activer le blocage des TPE",
            "warning": "Vous êtes sur le point d'activer le blocage des nouveaux TPE.",
            "validate_question": "Souhaitez-vous continuer ?",
            "success": "Blocage des nouveaux TPE activé avec succès !",
            "error": "L'activation du blocage des nouveaux TPE est échouée"
        },
        "unblock_new_pos": {
            "title": "Désactiver le blocage des TPE",
            "warning": "Vous êtes sur le point de désactiver le blocage des nouveaux TPE.",
            "validate_question": "Souhaitez-vous continuer ?",
            "success": "Blocage des nouveaux TPE désactivé avec succès !",
            "error": "La désactivation du blocage des nouveaux TPE est échouée"
        },
        "update_subscription_plan": {
            "title": "Modifier l'offre",
            "text": "Attention la facturation du mois en cours sera faite sur la nouvelle offre  \"{{planLabel}}\".",
            "confirm": "Souhaitez-vous continuer ?",
            "success": "Mise à jour de l'offre effectuée avec succès !",
            "error": "Une erreur est survenue lors de la modification de l'offre.",
            "steps": {
                "select_plan": "Étape {{step}} sur {{maxStep}} : Sélection d'une offre",
                "confirm": "Étape {{step}} sur {{maxStep}} : Confirmation de la modification de l'offre"
            }
        },
        "add_existing_plan": {
            "title": "Ajouter une offre existante"
        }
    },
    "toast": {
        "success": {
            "delete_access": "Le client a bien été supprimé de l'offre",
            "delete_allowed_client": "Le client a bien été supprimé de l'offre"
        },
        "error": {
            "delete_access": "Le client n'a pas pu être supprimé de l'offre",
            "CLIENT_ALREADY_ALLOWED": "Un des clients sélectionnés est déjà client de l'offre",
            "SUBSCRIPTION_PLAN_ALREADY_ALLOWED": "Le client est déjà client de l'une des offres selectionnées",
            "SUBSCRIPTION_PLAN_IS_PARENT_OFFER": "Ce client ne peut pas être supprimé de cette offre car cette dernière est utilisée comme offre parente",
            "UNKNOWN_ERROR": "Une erreur inconnue est survenue.",
            "ALREADY_EXISTS": "Ce code produit est déjà utilisé"
        }
    }
}